export default "__VITE_ASSET__656b8151__"